import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { baseToSelectOption } from '../../../academicOffers/courses/utils';
import { getFormDataRequest } from '../api';

const getFormDataAction = actionKitImpFunction(async () => {
  const response = await getFormDataRequest();
  if (response.error) {
    throw new Error('Error fetching form data');
  }

  const { data } = response;

  return {
    schools: baseToSelectOption(data?.schools),
    campuses: baseToSelectOption(data?.campuses),
    modalities: baseToSelectOption(data?.modalities),
  };
});

export { getFormDataAction };
